export default {
    props: {
        value: {
            required: false,
            default: null,
        },
        errors: {
            required: false,
            default: () => {
                return {}
            },
        }
    },

    data() {
        return {
            innerValue: null,
        }
    },

    created() {
        this.innerValue = this.value;
    },

    watch: {
        innerValue(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    },

    computed: {
        hasError() {
            return this.name in this.errors;
        }
    }
}
